class Util {
    toQueryString(json, prefix) {
        if (!json) return '';
        return Object.keys(json)
            .map(
                (key) =>
                    (prefix ? prefix + '.' : '') +
                    encodeURIComponent(key) +
                    '=' +
                    (json[key] != null ? encodeURIComponent(json[key]) : '')
            )
            .join('&');
    }

    toPersianCurrency(num) {
        num = String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        let len = num.length;
        let res = '';
        let pos;
        let persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

        for (let i = 0; i < len; i++) {
            if ((pos = persianNumbers[num.charAt(i)])) {
                res += pos;
            } else {
                res += num.charAt(i);
            }
        }
        return res + ' تومان';
    }
}
const util = new Util();
export default util;
